import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"
import { DURATION } from "../data/globalStyles"

const styles = {
  container: {
    minHeight: "92px",
    width: "311px",
    maxWidth: "311px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 0.5rem 0.5rem 0",
    border: `1px solid ${colors.black}`,
    backgroundColor: colors.white,
    color: colors.black,
    transition: `background-color ${DURATION} ease-in-out, color ${DURATION} ease-in-out`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: colors.black,
      color: colors.white,
    },
    "&:focus": {
      backgroundColor: colors.black,
      color: colors.white,
    },
    "@media only screen and (max-width: 810px)": {
      flex: "none",
      minHeight: "70px",
      maxWidth: "235px",
      width: "90%",
    },
  },
  text: {
    margin: "0 15px",
    fontWeight: "500",
    lineHeight: 1.2,
    fontSize: "calc(16px + (22 - 16) * ((100vw - 300px) / (1600 - 300)))",
    textDecoration: "none",
    textAlign: "center",
  },
}

const AnswerButton = ({ classes, id, text, onClick }) => {
  const keyHandler = ({ code }) => {
    if (code === "Enter") {
      onClick()
    }
    //get this to fire every time an answer button is clicked
    if (window.parent && window.parent.dataLayer) {
      window.parent.dataLayer.push({
        event: "datavisualization-baSidesQuiz-answerButton",
        "gtm.elementUrl": text,
      })
    }
  }

  return (
    <div
      key={`${id}-${text}`}
      className={classes.container}
      onClick={onClick}
      onKeyDown={(e) => keyHandler(e)}
      tabIndex="0">
      <h2 className={classes.text}>{text}</h2>
    </div>
  )
}

export default withStyles(styles)(AnswerButton)
